import { FC } from 'react';
import SuperCascader from '../SuperCascader';
import SimpleFormItem from './subpage/simpleFormItem';
import { BaseSimpleFormProps, SimpleFormItemEnum } from './interface';
import { SuperCascaderProps } from '../SuperCascader/interface';

export interface SimpleFormCascaderProps extends BaseSimpleFormProps {
  cascaderProps?: SuperCascaderProps;
}
const disabledStyle = {};
const SimpleFormCascader: FC<SimpleFormCascaderProps> = props => {
  const { cascaderProps, ...restProps } = props;
  const normFile = (e: any) => {
    if (cascaderProps?.multiple) {
      return e.map?.((item: any) => item?.slice?.(-1)?.[0])
    }
    if (e && e.length) return e.slice?.(-1)?.[0];
    return undefined;
  };
  return (
    <SimpleFormItem
      {...restProps}
      valuePropName="cascaderValue"
      getValueFromEvent={normFile}
    >
      <SuperCascader
        isDetail={true}
        disabledStyle={disabledStyle}
        {...cascaderProps}
      />
    </SimpleFormItem>
  );
};

SimpleFormCascader.displayName = SimpleFormItemEnum.simpleFormCascader;

export default SimpleFormCascader;